module.exports = "/work-site/img/empty.558ef09c.png";